/**
 * Skeleton da Comunicação — header padrão + abas (atrasados / hoje /
 * próximos) + cards de disparo de WhatsApp.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Abas */}
      <div className="h-11 w-72 rounded-xl border border-slate-200 bg-white" />

      {/* Cards de disparo */}
      <div className="flex flex-col gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white px-5 py-4">
            <div className="h-10 w-10 shrink-0 rounded-full bg-slate-200" />
            <div className="flex-1">
              <div className="h-4 w-56 rounded bg-slate-200" />
              <div className="mt-2 h-3 w-40 rounded bg-slate-100" />
            </div>
            <div className="h-9 w-28 rounded-lg bg-slate-200" />
          </div>
        ))}
      </div>
    </div>
  );
}
